import { Box, Text } from "@mantine/core";
import { useStyles } from "../../styles/TaxInfoSidebar.styles";
import type { Section } from "../../types";

interface NavigationItemProps {
  section: Section;
  isActive: boolean;
  onClick: () => void;
}

const NavigationItem: React.FC<NavigationItemProps> = ({
  section,
  isActive,
  onClick,
}) => {
  const { classes, cx } = useStyles();

  return (
    <Box
      className={cx(classes.sectionItem, {
        [classes.activeSection]: isActive,
      })}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick()}
    >
      <Text size="sm">{section.label}</Text>
    </Box>
  );
};

export default NavigationItem;
